import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '../../../environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  emailForm: UntypedFormGroup;

  constructor(
    private _fb: UntypedFormBuilder,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.emailForm = this._fb.group({
      from: [null, Validators.required],
      name: [null, Validators.required],
      message: [null, Validators.required]
    });
  }

  async send() {
    if (this.emailForm.valid) {
      await this.http.post(env.apiUrl + '/email/send', {
        from: this.emailForm.get('from').value,
        name: this.emailForm.get('name').value,
        message: this.emailForm.get('message').value
      }).toPromise().then(res => console.log('success'));
    } else {
      Object.keys(this.emailForm.controls).forEach(field => { // {1}
        const control = this.emailForm.get(field);            // {2}
        control.markAsTouched({ onlySelf: true });       // {3}
      });
    }
  }

  isFieldValid(field: string) {
    return !this.emailForm.get(field).valid && this.emailForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'is-invalid': this.isFieldValid(field)
    };
  }

}
